const packageJson = require("./../package.json");

const PACKAGE_VERSION = packageJson.version;
//const PACKAGE_VERSION = process.env.npm_package_version || '3.0.0';
const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || "0.1";

module.exports.APP_VERSION = `${PACKAGE_VERSION}-${BUILD_NUMBER}`;
